"use client";
import { motion } from "motion/react";
import { useAnimationSequence } from "./useAnimationSequence";
import {
  middleGradient,
  middleGradientReset,
  middleGradientReversed,
  middleGradientReversedReset,
  outerGradient,
  outerGradientReset,
  outerGradientReversed,
  outerGradientReversedReset,
  showOuterGradientPaths,
  showMiddleGradientPaths,
  showReversedMiddleGradientPaths,
  showReversedOuterGradientPaths,
} from "./animations";

export const SolidarityLatticeDiagram = () => {
  const scope = useAnimationSequence([
    {
      animation: middleGradient,
      playCount: -1,
    },
    {
      animation: showReversedMiddleGradientPaths,
      playCount: -1,
    },
    {
      animation: middleGradientReset,
      playCount: -1,
    },
    {
      animation: outerGradient,
      playCount: -1,
    },
    {
      animation: showReversedOuterGradientPaths,
      playCount: -1,
    },
    {
      animation: middleGradientReversed,
      playCount: -1,
    },
    {
      animation: outerGradientReset,
      playCount: -1,
    },
    {
      animation: outerGradientReversed,
      playCount: -1,
    },
    {
      animation: showMiddleGradientPaths,
      playCount: -1,
    },
    {
      animation: middleGradientReversedReset,
      playCount: -1,
    },
    {
      animation: showOuterGradientPaths,
      playCount: -1,
    },
    {
      animation: outerGradientReversedReset,
      playCount: -1,
    },
  ]);

  return (
    <svg
      version="1.1"
      viewBox="0 0 1748.6807 769.6786"
      xmlSpace="preserve"
      id="svg58"
      xmlns="http://www.w3.org/2000/svg"
      ref={scope}
    >
      <defs id="defs5">
        <motion.linearGradient
          id="linearGradient14"
          initial={{
            x1: "100%",
            x2: "0%",
            y1: "90%",
            y2: "10%",
            rotate: 90,
            translateY: 5,
          }}
        >
          <stop
            style={{ stopColor: "#f2bd00", stopOpacity: 1 }}
            offset="0"
            id="stop11"
          />
          <stop
            style={{ stopColor: "#cfa344", stopOpacity: 1 }}
            offset="0.27950308"
            id="stop12"
          />
          <stop
            style={{ stopColor: "#916903", stopOpacity: 1 }}
            offset="0.3894413"
            id="stop14"
          />
          <stop
            style={{ stopColor: "#fff8e9", stopOpacity: 1 }}
            offset="0.54013944"
            id="stop13"
          />
          <stop
            style={{ stopColor: "#916903", stopOpacity: 1 }}
            offset="0.7494413"
            id="stop14"
          />
          <stop
            style={{ stopColor: "#f2bd00", stopOpacity: 1 }}
            offset="96894413"
            id="stop11"
          />
        </motion.linearGradient>
        <motion.linearGradient
          id="linearGradient15"
          initial={{
            x1: "100%",
            x2: "0%",
            y1: "0%",
            y2: "10%",
          }}
        >
          <stop
            style={{ stopColor: "#f2bd00", stopOpacity: 1 }}
            offset="0"
            id="stop11"
          />
          <stop
            style={{ stopColor: "#cfa344", stopOpacity: 1 }}
            offset="0.27950308"
            id="stop12"
          />
          <stop
            style={{ stopColor: "#916903", stopOpacity: 1 }}
            offset="0.3894413"
            id="stop14"
          />
          <stop
            style={{ stopColor: "#fff8e9", stopOpacity: 1 }}
            offset="0.54013944"
            id="stop13"
          />
          <stop
            style={{ stopColor: "#916903", stopOpacity: 1 }}
            offset="0.7494413"
            id="stop14"
          />
          <stop
            style={{ stopColor: "#f2bd00", stopOpacity: 1 }}
            offset="96894413"
            id="stop11"
          />
        </motion.linearGradient>
        <motion.linearGradient
          id="gold-gradient-white-highlight-moving-left"
          initial={{
            x1: "200%",
            x2: "100%",
            y1: "0%",
            y2: "10%",
          }}
        >
          <stop
            style={{ stopColor: "#f2bd00", stopOpacity: 1 }}
            offset="0"
            id="stop11"
          />
          <stop
            style={{ stopColor: "#cfa344", stopOpacity: 1 }}
            offset="0.27950308"
            id="stop12"
          />
          <stop
            style={{ stopColor: "#fff8e9", stopOpacity: 1 }}
            offset="0.54013944"
            id="stop13"
          />
          <stop
            style={{ stopColor: "#d5a22a", stopOpacity: 1 }}
            offset="0.96894413"
            id="stop14"
          />
        </motion.linearGradient>
        <motion.linearGradient
          id="reversed-gold-gradient-white-highlight-moving-left"
          initial={{
            x1: "200%",
            x2: "100%",
            y1: "0%",
            y2: "10%",
          }}
        >
          <stop
            style={{ stopColor: "#d5a22a", stopOpacity: 1 }}
            offset="0"
            id="stop14"
          />
          <stop
            style={{ stopColor: "#cfa344", stopOpacity: 1 }}
            offset="0.27950308"
            id="stop12"
          />
          <stop
            style={{ stopColor: "#fff8e9", stopOpacity: 1 }}
            offset="0.54013944"
            id="stop13"
          />
          <stop
            style={{ stopColor: "#f2bd00", stopOpacity: 1 }}
            offset="0.96894413"
            id="stop11"
          />
        </motion.linearGradient>
        <motion.linearGradient
          id="gold-gradient-white-highlight-moving-right"
          initial={{
            x1: "-100%",
            x2: "0%",
            y1: "0%",
            y2: "10%",
          }}
        >
          <stop
            style={{ stopColor: "#f2bd00", stopOpacity: 1 }}
            offset="0"
            id="stop11"
          />
          <stop
            style={{ stopColor: "#cfa344", stopOpacity: 1 }}
            offset="0.27950308"
            id="stop12"
          />
          <stop
            style={{ stopColor: "#fff8e9", stopOpacity: 1 }}
            offset="0.54013944"
            id="stop13"
          />
          <stop
            style={{ stopColor: "#d5a22a", stopOpacity: 1 }}
            offset="0.96894413"
            id="stop14"
          />
        </motion.linearGradient>
        <motion.linearGradient
          id="reversed-gold-gradient-white-highlight-moving-right"
          initial={{
            x1: "-100%",
            x2: "0%",
            y1: "0%",
            y2: "10%",
          }}
        >
          <stop
            style={{ stopColor: "#d5a22a", stopOpacity: 1 }}
            offset="0"
            id="stop14"
          />
          <stop
            style={{ stopColor: "#cfa344", stopOpacity: 1 }}
            offset="0.27950308"
            id="stop12"
          />
          <stop
            style={{ stopColor: "#fff8e9", stopOpacity: 1 }}
            offset="0.54013944"
            id="stop13"
          />
          <stop
            style={{ stopColor: "#f2bd00", stopOpacity: 1 }}
            offset="0.96894413"
            id="stop11"
          />
        </motion.linearGradient>
        <motion.linearGradient
          id="gold-gradient-white-highlight-large-moving-left"
          initial={{
            x1: "100%",
            x2: "200%",
            y1: "0%",
            y2: "-10%",
          }}
        >
          <stop
            style={{ stopColor: "#d5a22a", stopOpacity: 1 }}
            offset="0"
            id="stop11"
          />
          <stop
            style={{ stopColor: "#cfa344", stopOpacity: 1 }}
            offset="0.27950308"
            id="stop12"
          />
          <stop
            style={{ stopColor: "#fff8e9", stopOpacity: 1 }}
            offset="0.54013944"
            id="stop13"
          />
          <stop
            style={{ stopColor: "#f2bd00", stopOpacity: 1 }}
            offset="0.96894413"
            id="stop14"
          />
        </motion.linearGradient>
        <motion.linearGradient
          id="reversed-gold-gradient-white-highlight-large-moving-left"
          initial={{
            x1: "100%",
            x2: "200%",
            y1: "0%",
            y2: "-10%",
          }}
        >
          <stop
            style={{ stopColor: "#f2bd00", stopOpacity: 1 }}
            offset="0"
            id="stop11"
          />
          <stop
            style={{ stopColor: "#cfa344", stopOpacity: 1 }}
            offset="0.27950308"
            id="stop12"
          />
          <stop
            style={{ stopColor: "#fff8e9", stopOpacity: 1 }}
            offset="0.54013944"
            id="stop13"
          />
          <stop
            style={{ stopColor: "#d5a22a", stopOpacity: 1 }}
            offset="0.96894413"
            id="stop14"
          />
        </motion.linearGradient>
        <motion.linearGradient
          id="gold-gradient-white-highlight-large-moving-right"
          initial={{
            x1: "-100%",
            x2: "-200%",
            y1: "0%",
            y2: "10%",
          }}
        >
          <stop
            style={{ stopColor: "#d5a22a", stopOpacity: 1 }}
            offset="0"
            id="stop14"
          />
          <stop
            style={{ stopColor: "#cfa344", stopOpacity: 1 }}
            offset="0.27950308"
            id="stop12"
          />
          <stop
            style={{ stopColor: "#fff8e9", stopOpacity: 1 }}
            offset="0.54013944"
            id="stop13"
          />
          <stop
            style={{ stopColor: "#f2bd00", stopOpacity: 1 }}
            offset="0.96894413"
            id="stop11"
          />
        </motion.linearGradient>
        <motion.linearGradient
          id="reversed-gold-gradient-white-highlight-large-moving-right"
          initial={{
            x1: "-100%",
            x2: "-200%",
            y1: "0%",
            y2: "10%",
          }}
        >
          <stop
            style={{ stopColor: "#f2bd00", stopOpacity: 1 }}
            offset="0"
            id="stop11"
          />
          <stop
            style={{ stopColor: "#cfa344", stopOpacity: 1 }}
            offset="0.27950308"
            id="stop12"
          />
          <stop
            style={{ stopColor: "#fff8e9", stopOpacity: 1 }}
            offset="0.54013944"
            id="stop13"
          />
          <stop
            style={{ stopColor: "#d5a22a", stopOpacity: 1 }}
            offset="0.96894413"
            id="stop14"
          />
        </motion.linearGradient>
        <motion.linearGradient id="linearGradient92">
          <stop
            style={{ stopColor: "#e4b642", stopOpacity: 1 }}
            offset="0"
            id="stop93"
          />
          <stop
            style={{ stopColor: "#d4a839", stopOpacity: 1 }}
            offset="0.2670728"
            id="stop186"
          />
          <stop
            style={{ stopColor: "#ae8323", stopOpacity: 1 }}
            offset="0.53416148"
            id="stop184"
          />
          <stop
            style={{ stopColor: "#ba902b", stopOpacity: 1 }}
            offset="0.70807454"
            id="stop185"
          />
          <stop
            style={{ stopColor: "#ad8424", stopOpacity: 1 }}
            offset="1"
            id="stop92"
          />
        </motion.linearGradient>
        <motion.linearGradient
          xlinkHref="#linearGradient92"
          id="linearGradient93"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(323.53323,206.77503)"
        />
        <motion.linearGradient
          xlinkHref="#linearGradient94"
          id="linearGradient95"
          initial={{
            x1: "100%",
            x2: "0%",
            y1: "0%",
            y2: "10%",
          }}
          animate={{
            rotate: [0, 360],
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            repeatDelay: 0,
            repeatType: "loop",
            ease: "linear",
          }}
          gradientUnits="userSpaceOnUse"
          spreadMethod="pad"
          gradientTransform="matrix(0.48678198,0,0,0.48677526,1153.2143,198.9074)"
        />
        <clipPath clipPathUnits="userSpaceOnUse" id="clipPath78">
          <path
            id="path78"
            style={{
              display: "inline",
              fill: "#000000",
              fillOpacity: 1,
              stroke: "none",
              strokeWidth: 15,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: 16.6,
              strokeDasharray: "none",
              paintOrder: "markers stroke fill",
            }}
            d="m 1117.1284,56.801034 221.4744,30.72477 84.6348,117.918996 c -13.1899,-0.85584 -26.0869,-3.05913 -40.1219,-0.0278 l -40.0323,-7.49295 -298.0696,6.9965 -123.96752,-0.82231 c -33.86613,0.17834 -61.50094,-1.48988 -97.14714,0.24904 l -80.10918,20.64473 -198.15677,8.61551 -149.06962,-12.90203 -41.44653,-12.62196 -22.7709,6.04582 76.96191,-104.35658 146.84535,-25.276648 193.61874,37.003158 c 48.7735,13.57968 133.22761,-4.06263 158.7967,7.97451 z m 78.9851,647.705236 193.7081,-66.20405 120.7598,-102.09822 c -57.3384,14.81483 -113.9873,29.95214 -174.2998,21.08946 l -41.8924,-10.25738 -112.9528,22.98294 -179.0621,-20.82118 -91.08111,-2.25119 c -50.1766,4.25758 -78.46422,-3.55798 -119.00135,-7.14091 l -272.96896,6.61594 -100.5826,-7.2707 c -43.25181,11.96037 -82.48747,15.96671 -127.29569,5.01204 l -5.29381,42.16842 359.48729,125.2716 273.5695,-71.05505 z"
          />
        </clipPath>
        <linearGradient
          xlinkHref="#linearGradient94"
          id="linearGradient3"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.48678198,0,0,0.48677526,1153.2143,198.9074)"
          x1="-501.90295"
          y1="-835.94324"
          x2="-501.90295"
          y2="1610.9867"
          spreadMethod="pad"
        />
        <linearGradient
          xlinkHref="#linearGradient94"
          id="linearGradient4"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.48678198,0,0,0.48677526,1153.2143,198.9074)"
          x1="-501.90295"
          y1="-835.94324"
          x2="-501.90295"
          y2="1610.9867"
          spreadMethod="pad"
        />
        <linearGradient
          xlinkHref="#linearGradient94"
          id="linearGradient5"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.48678198,0,0,0.48677526,1153.2143,198.9074)"
          x1="-501.90295"
          y1="-835.94324"
          x2="-501.90295"
          y2="1610.9867"
          spreadMethod="pad"
        />
        <linearGradient
          xlinkHref="#linearGradient94"
          id="linearGradient6"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.48678198,0,0,0.48677526,1153.2143,198.9074)"
          x1="-501.90295"
          y1="-835.94324"
          x2="-501.90295"
          y2="1610.9867"
          spreadMethod="pad"
        />
      </defs>
      <g
        id="layer1"
        style={{ display: "inline" }}
        transform="translate(218.51103,100.34835)"
      >
        <path
          style={{
            display: "inline",
            fill: "none",
            strokeWidth: 15.72,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeDasharray: "none",
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          stroke="url(#reversed-gold-gradient-white-highlight-large-moving-left)"
          d="M 879.9079,526.54489 C 801.41705,625.43867 660.00675,649.67809 559.30173,648.061 458.59671,646.44391 353.771,581.91413 337.38566,515.64508"
          id="path22-reversed-gradient"
          clipPath="url(#clipPath78)"
          transform="translate(-218.51103,-104.34835)"
        />
        <path
          style={{
            display: "inline",
            fill: "none",

            strokeWidth: 15.72,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeDasharray: "none",
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          stroke="url(#reversed-gold-gradient-white-highlight-large-moving-right)"
          d="m 1403.2535,213.55417 c -21.9033,-34.06078 -63.7031,-106.55379 -191.5466,-107.53629 -123.1242,-0.94623 -269.27922,42.70623 -334.87109,97.95388"
          id="path23-reversed-gradient"
          clipPath="url(#clipPath78)"
          transform="translate(-218.51103,-104.34835)"
        />
        <path
          style={{
            display: "inline",
            fill: "none",
            strokeWidth: 15.72,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeDasharray: "none",
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          stroke="url(#reversed-gold-gradient-white-highlight-large-moving-left)"
          d="m 355.67508,215.88948 c 32.11538,-60.92463 106.09691,-104.93677 207.28921,-106.08791 146.96177,-1.6718 248.6553,45.23074 314.60547,94.6496"
          id="path24-reversed-gradient"
          clipPath="url(#clipPath78)"
          transform="translate(-218.51103,-104.34835)"
        />
        <path
          style={{
            display: "inline",
            fill: "none",
            strokeWidth: 15.72,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeDasharray: "none",
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          stroke="url(#reversed-gold-gradient-white-highlight-large-moving-right)"
          d="m 871.0571,525.66184 c 40.57117,64.92994 203.1827,125.01178 293.6455,123.6744 115.3244,-1.70494 232.8339,-33.3806 256.5776,-113.46065"
          id="path25-reversed-gradient"
          clipPath="url(#clipPath78)"
          transform="translate(-218.51103,-104.34835)"
        />
        <path
          style={{
            display: "inline",
            fill: "none",

            strokeWidth: 15.72,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeDasharray: "none",
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          stroke="url(#gold-gradient-white-highlight-large-moving-left)"
          d="M 879.9079,526.54489 C 801.41705,625.43867 660.00675,649.67809 559.30173,648.061 458.59671,646.44391 353.771,581.91413 337.38566,515.64508"
          id="path22"
          clipPath="url(#clipPath78)"
          transform="translate(-218.51103,-104.34835)"
        />
        <path
          style={{
            display: "inline",
            fill: "none",

            strokeWidth: 15.72,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeDasharray: "none",
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          stroke="url(#gold-gradient-white-highlight-large-moving-right)"
          d="m 1403.2535,213.55417 c -21.9033,-34.06078 -63.7031,-106.55379 -191.5466,-107.53629 -123.1242,-0.94623 -269.27922,42.70623 -334.87109,97.95388"
          id="path23"
          clipPath="url(#clipPath78)"
          transform="translate(-218.51103,-104.34835)"
        />
        <path
          style={{
            display: "inline",
            fill: "none",
            strokeWidth: 15.72,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeDasharray: "none",
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          stroke="url(#gold-gradient-white-highlight-large-moving-left)"
          d="m 355.67508,215.88948 c 32.11538,-60.92463 106.09691,-104.93677 207.28921,-106.08791 146.96177,-1.6718 248.6553,45.23074 314.60547,94.6496"
          id="path24"
          clipPath="url(#clipPath78)"
          transform="translate(-218.51103,-104.34835)"
        />
        <path
          style={{
            display: "inline",
            fill: "none",
            strokeWidth: 15.72,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeDasharray: "none",
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          stroke="url(#gold-gradient-white-highlight-large-moving-right)"
          d="m 871.0571,525.66184 c 40.57117,64.92994 203.1827,125.01178 293.6455,123.6744 115.3244,-1.70494 232.8339,-33.3806 256.5776,-113.46065"
          id="path25"
          clipPath="url(#clipPath78)"
          transform="translate(-218.51103,-104.34835)"
        />

        <path
          style={{
            fill: "none",
            stroke: "#43433b",
            strokeWidth: 0,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeDasharray: "none",
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          d="m 271.99476,196.91717 c 34.51166,26.65983 38.81734,25.89328 68.22142,71.44782"
          id="path8"
        />
        <path
          style={{
            display: "none",
            fill: "none",
            stroke: "#43433b",
            strokeWidth: 7.55906,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeDasharray: "none",
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          d="m 615.29676,429.59768 c 63.24296,9.22925 73.53357,8.55835 139.90404,-0.76307"
          id="path34"
        />
        <path
          style={{
            display: "none",
            fill: "none",
            fillOpacity: 1,
            stroke: "#43433b",
            strokeWidth: 6.04724,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeDasharray: "none",
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          d="M -16.111898,257.47885 C -4.194195,221.48186 25.968027,177.69813 53.650036,153.20842"
          id="path64"
        />
        <path
          style={{
            display: "none",
            fill: "none",
            fillOpacity: 1,
            stroke: "#43433b",
            strokeWidth: 6.04724,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeDasharray: "none",
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          d="m 1073.8321,425.89138 c 73.7571,9.31936 138.6273,17.46764 215.4809,-9.17494"
          id="path65"
        />
        <g
          id="g70"
          style={{ display: "inline" }}
          transform="rotate(1.346823,1038.7444,-163.12389)"
        >
          <path
            style={{
              display: "none",
              fill: "none",
              fillOpacity: 1,
              stroke: "#c7433b",
              strokeWidth: 6.04724,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: 16.6,
              strokeDasharray: "none",
              strokeOpacity: 1,
              paintOrder: "markers stroke fill",
            }}
            id="path68"
            d="m 1439.7279,266.52882 c 33.9971,23.26239 55.3459,38.4304 77.4638,88.59465"
          />
          <path
            style={{
              display: "none",
              fill: "none",
              fillOpacity: 1,
              stroke: "#c7433b",
              strokeWidth: 6.84538,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: 16.6,
              strokeDasharray: "none",
              strokeOpacity: 1,
              paintOrder: "markers stroke fill",
            }}
            d="m 1241.8626,127.18291 c 38.4841,26.33264 76.8165,63.23359 101.8536,120.01869"
            id="path69"
          />
          <text
            xmlSpace="preserve"
            style={{
              fontSize: 29.3333,
              lineHeight: 1.6,
              fontFamily: "Alegreya Sans",
              textAlign: "center",
              letterSpacing: 0,
              wordSpacing: 2,
              direction: "ltr",
              textAnchor: "middle",
              fill: "none",
              fillOpacity: 1,
              stroke: "#c7433b",
              strokeWidth: 0.823937,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: 16.6,
              strokeDasharray: "none",
              strokeOpacity: 1,
              paintOrder: "markers stroke fill",
            }}
            id="text79"
            transform="rotate(1.6148289,1056.0907,56.904354)"
          >
            <textPath xlinkHref="#path69" startOffset="50%" id="textPath79">
              <tspan
                id="tspan79"
                style={{
                  fill: "#c5dafbff",
                  fillOpacity: 1,
                  stroke: "#c5dafbff",
                  strokeWidth: 0.823937,
                  strokeDasharray: "none",
                  strokeOpacity: 1,
                }}
              >
                Movement
              </tspan>
            </textPath>
          </text>
        </g>
        <path
          style={{
            display: "none",
            fill: "none",
            stroke: "#43433b",
            strokeWidth: 7.55906,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeDasharray: "none",
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          d="m 690.78572,138.13103 c 48.56452,19.11523 92.33322,62.40313 120.92625,107.98401"
          id="path32"
          transform="translate(-3.2948114e-6)"
        />
        <g
          id="g35"
          transform="matrix(0.89638703,0.07174853,-0.07174853,0.89638703,-111.57201,-125.83996)"
          style={{ display: "inline" }}
        >
          <text
            fill="#c5dafbff"
            fontSize="19.8348"
            stroke="#c5dafbff"
            strokeWidth="1.02389"
            text-align="center"
            textAnchor="middle"
            wordSpacing="0.77145"
            style={{
              fontSize: 32,
              lineHeight: 1.3,
              fontFamily: "Alegreya Sans",
              letterSpacing: 0,
              whiteSpace: "pre",
              display: "inline",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: 16.6,
              paintOrder: "markers stroke fill",
            }}
            xmlSpace="preserve"
            id="text46"
          >
            <textPath xlinkHref="#path82" startOffset="50%" id="textPath83">
              <tspan
                style={{ fontSize: 32, lineHeight: 1.3, strokeWidth: 1.02389 }}
                id="tspan45"
              >
                Indigenous
              </tspan>
            </textPath>
          </text>
          <text
            fill="#c5dafbff"
            fontSize="19.8348"
            stroke="#c5dafbff"
            strokeWidth="1.02389"
            text-align="center"
            textAnchor="middle"
            wordSpacing="0.77145"
            style={{
              fontSize: 32,
              lineHeight: 1.3,
              fontFamily: "Alegreya Sans",
              letterSpacing: 0,
              whiteSpace: "pre",
              display: "inline",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: 16.6,
              paintOrder: "markers stroke fill",
            }}
            xmlSpace="preserve"
            id="text31"
            transform="rotate(-2.4830237,3126.9944,-4966.5968)"
          >
            <textPath xlinkHref="#path32" startOffset="50%" id="textPath32">
              <tspan
                style={{ fontSize: 32, lineHeight: 1.3, strokeWidth: 1.02389 }}
                id="tspan29"
              >
                {" "}
                Seedkeepers
              </tspan>
            </textPath>
          </text>
        </g>
        <g
          id="g72"
          transform="matrix(0.86140613,0.02427324,-0.02427324,0.86140613,153.0279,19.229654)"
          style={{ display: "inline" }}
        >
          <text
            fill="#c5dafbff"
            fontSize="18.5061"
            stroke="#c5dafbff"
            strokeWidth="1.04178"
            text-align="center"
            textAnchor="middle"
            wordSpacing="0.783966"
            style={{
              fontSize: 34.8972,
              lineHeight: 1.3,
              fontFamily: "Alegreya Sans",
              letterSpacing: 0,
              whiteSpace: "pre",
              display: "inline",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: 16.6,
              paintOrder: "markers stroke fill",
            }}
            xmlSpace="preserve"
            id="text13"
            transform="matrix(0.91697833,0,0,0.91697833,-166.58652,-64.73413)"
          >
            <textPath
              xlinkHref="#path70"
              startOffset="50%"
              id="textPath71"
              style={{ strokeWidth: 1.04178 }}
            >
              <tspan
                id="tspan12"
                style={{ fontSize: 34.8972, strokeWidth: 1.04178 }}
              >
                {" "}
                Communities
              </tspan>
            </textPath>
          </text>
          <text
            fill="#c5dafbff"
            stroke="#c5dafbff"
            strokeWidth="1.04178"
            text-align="center"
            textAnchor="middle"
            wordSpacing="0.783966"
            style={{
              fontSize: 34.8972,
              lineHeight: 1.3,
              fontFamily: "Alegreya Sans",
              letterSpacing: 0,
              whiteSpace: "pre",
              display: "inline",
              strokeWidth: 1.04269,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: 16.6,
              strokeDasharray: "none",
              paintOrder: "markers stroke fill",
            }}
            xmlSpace="preserve"
            id="text70"
            transform="matrix(0.91697833,0,0,0.91697833,-164.36982,-66.319001)"
          >
            <textPath
              xlinkHref="#path71"
              startOffset="50%"
              id="textPath72"
              style={{ strokeWidth: 1.04269, strokeDasharray: "none" }}
            >
              <tspan
                id="tspan70"
                style={{
                  fontSize: 34.8972,
                  strokeWidth: 1.04269,
                  strokeDasharray: "none",
                }}
              >
                Marginalized{" "}
              </tspan>
            </textPath>
          </text>
        </g>
        <g
          transform="matrix(1.6322825,0,0,1.630359,-120.83094,-247.90263)"
          id="g34"
          style={{
            stroke: "#aa6c3d",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeOpacity: 1,
          }}
        >
          <text
            x="247.88408"
            y="136.7122"
            fill="#9c325b"
            fontFamily="Impact"
            fontSize="19.121"
            letterSpacing="0.18597"
            stroke="#9c325b"
            strokeWidth="1.2596"
            wordSpacing="0.44814"
            style={{
              fontSize: 26.1547,
              lineHeight: 1,
              fill: "#aa6c3d",
              fillOpacity: 1,
              stroke: "#aa6c3d",
              strokeOpacity: 1,
              paintOrder: "markers stroke fill",
            }}
            xmlSpace="preserve"
            id="text32"
          >
            <tspan
              x="247.88408"
              y="136.7122"
              fill="#9c325b"
              fontFamily="Alegreya Sans"
              fontWeight="bold"
              letterSpacing="0.18597"
              stroke="#9c325b"
              strokeWidth="1.2596"
              style={{
                fontSize: 26.1547,
                lineHeight: 1,
                fill: "#aa6c3d",
                fillOpacity: 1,
                stroke: "#aa6c3d",
                strokeOpacity: 1,
              }}
              id="tspan32"
            >
              Products
            </tspan>
          </text>
        </g>
        <g
          transform="matrix(1.5727219,0,0,1.5708685,547.18306,-365.38031)"
          id="g30"
          style={{
            stroke: "#9c325b",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeOpacity: 1,
          }}
        >
          <text
            x="229.17833"
            y="220.40282"
            fill="#c7433bff"
            fontFamily="Impact"
            fontSize="19.121"
            letterSpacing="0.18597"
            stroke="#c7433bff"
            strokeWidth="1.2596"
            wordSpacing="0.44814"
            style={{
              fontSize: 27.1452,
              lineHeight: 1,
              stroke: "#c7433bff",
              strokeOpacity: 1,
              paintOrder: "markers stroke fill",
            }}
            xmlSpace="preserve"
            id="text30"
          >
            <tspan
              x="229.17833"
              y="220.40282"
              fill="#c7433bff"
              fontFamily="Alegreya Sans"
              fontWeight="bold"
              letterSpacing="0.18597"
              stroke="#c7433bff"
              strokeWidth="1.2596"
              style={{
                fontSize: 27.1452,
                lineHeight: 1,
                stroke: "#c7433bff",
                strokeOpacity: 1,
              }}
              id="tspan28"
            >
              Resources
            </tspan>
          </text>
        </g>
        <text
          x="498.52158"
          y="700.41302"
          fill="#c7433bff"
          fontFamily="Impact"
          fontSize="29.9333"
          letterSpacing="0.18879"
          stroke="#c7433bff"
          strokeWidth="1.97201"
          wordSpacing="0.45495"
          style={{
            fontSize: 42.6667,
            lineHeight: 1,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            paintOrder: "markers stroke fill",
          }}
          xmlSpace="preserve"
          id="text33"
          transform="matrix(1.0005897,0,0,0.99941063,-218.51103,-100.34835)"
        >
          <tspan
            x="498.52158"
            y="700.41302"
            fill="#c7433bff"
            fontFamily="Alegreya Sans"
            fontWeight="bold"
            letterSpacing="0.291129"
            stroke="#c7433bff"
            strokeWidth="1.97201"
            style={{ fontSize: 42.6667, lineHeight: 1 }}
            id="tspan33"
          >
            Resources
          </tspan>
        </text>
        <text
          x="1124.517"
          y="700.69446"
          fill="#9c325b"
          fontFamily="Impact"
          fontSize="29.9333"
          letterSpacing="0.18879"
          stroke="#9c325b"
          strokeWidth="1.97201"
          wordSpacing="0.45495"
          style={{
            fontSize: 42.6667,
            lineHeight: 1,
            fill: "#aa6c3d",
            fillOpacity: 1,
            stroke: "#aa6c3d",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          xmlSpace="preserve"
          id="text37"
          transform="matrix(1.0005897,0,0,0.99941064,-218.51103,-100.34835)"
        >
          <tspan
            x="1124.517"
            y="700.69446"
            fill="#9c325b"
            fontFamily="Alegreya Sans"
            fontWeight="bold"
            letterSpacing="0.291129"
            stroke="#9c325b"
            strokeWidth="1.97201"
            style={{
              fontSize: 42.6667,
              lineHeight: 1,
              fill: "#aa6c3d",
              fillOpacity: 1,
              stroke: "#aa6c3d",
              strokeOpacity: 1,
            }}
            id="tspan37"
          >
            Products
          </tspan>
        </text>
        <text
          fill="#c5dafbff"
          fontSize="27.656"
          stroke="#c5dafbff"
          strokeWidth="1.42764"
          wordSpacing="1.3277"
          style={{
            fontSize: 42.6667,
            lineHeight: 1,
            fontFamily: "Alegreya Sans",
            letterSpacing: 0,
            display: "inline",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            paintOrder: "markers stroke fill",
          }}
          xmlSpace="preserve"
          id="text49"
          transform="translate(-21.786154)"
        >
          <textPath xlinkHref="#path34" id="textPath34">
            Farmers
          </textPath>
        </text>
        <text
          fill="#c5dafbff"
          fontFamily="Alegreya Sans"
          fontSize="23.6794"
          letterSpacing="0"
          stroke="#c5dafbff"
          strokeWidth="1.22233"
          text-align="center"
          textAnchor="middle"
          wordSpacing="0.79003"
          style={{
            fontSize: 42.6667,
            lineHeight: 1.3,
            display: "inline",
            paintOrder: "markers stroke fill",
          }}
          xmlSpace="preserve"
          id="text26"
          transform="translate(-67.331015,-33.32679)"
        >
          <textPath
            xlinkHref="#path8"
            startOffset="50%"
            id="textPath8"
            style={{ fontSize: 42.6667 }}
          >
            Soils
          </textPath>
        </text>
        <text
          fill="#c5dafbff"
          fontFamily="Alegreya Sans"
          fontSize="27.1932"
          letterSpacing="0"
          stroke="#c5dafbff"
          strokeWidth="1.40378"
          wordSpacing="0.90728"
          style={{
            fontSize: 42.6667,
            lineHeight: 1,
            display: "inline",
            paintOrder: "markers stroke fill",
          }}
          xmlSpace="preserve"
          id="text27"
          x="88.254898"
          y="437.46478"
          transform="translate(-1.3294812e-5)"
        >
          Seeds
        </text>
        <text
          fill="#c5dafbff"
          fontFamily="Alegreya Sans"
          fontSize="24.7982"
          letterSpacing="0"
          stroke="#c5dafbff"
          strokeWidth="1.28009"
          wordSpacing="0.82734"
          style={{
            fontSize: 42.6667,
            lineHeight: 1.3,
            display: "inline",
            paintOrder: "markers stroke fill",
          }}
          xmlSpace="preserve"
          id="text29"
          transform="rotate(-3.348782,232.07565,76.928468)"
        >
          <textPath xlinkHref="#path64" id="textPath64">
            {" "}
            <tspan style={{ fontSize: 40 }} id="tspan8">
              Waters
            </tspan>
          </textPath>
        </text>
        <text
          fill="#c5dafbff"
          fontSize="20.4616"
          stroke="#c5dafbff"
          strokeWidth="1.05626"
          wordSpacing="0.85343"
          style={{
            fontSize: 42.6667,
            lineHeight: 1,
            fontFamily: "Alegreya Sans",
            letterSpacing: 0,
            display: "inline",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            paintOrder: "markers stroke fill",
          }}
          xmlSpace="preserve"
          id="text16"
          transform="translate(-1.3294812e-5,8.0000033)"
        >
          <textPath xlinkHref="#path65" id="textPath65">
            Eaters/Public
          </textPath>
        </text>
        <text
          transform="matrix(0.99941701,0,0,1.0005833,-1.3294812e-5,3.0792708e-6)"
          x="1178.5647"
          y="295.74677"
          fill="#7fa139"
          fontSize="19.4231"
          letterSpacing="0.32404"
          stroke="#7fa139"
          strokeWidth="1.00263"
          text-align="center"
          textAnchor="middle"
          wordSpacing="-2.2188"
          style={{
            fontSize: 42.6667,
            lineHeight: 1,
            fontFamily: "Alegreya Sans",
            display: "inline",
            fill: "#67852f",
            fillOpacity: 1,
            stroke: "#67852f",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          xmlSpace="preserve"
          id="text17"
        >
          <tspan id="tspan47" x="1178.5647" y="295.74677">
            Community{" "}
          </tspan>
          <tspan id="tspan48" x="1178.7267" y="338.41345">
            Power
          </tspan>
        </text>
        <text
          transform="matrix(0.999441,0,0,1.0005593,-218.51103,-100.34835)"
          x="363.99371"
          y="419.17435"
          fill="#7fa139"
          fontFamily="Alegreya Sans"
          fontSize="30.092"
          letterSpacing="0.322967"
          stroke="#7fa139"
          strokeWidth="1.54822"
          text-align="center"
          textAnchor="middle"
          wordSpacing="-2.2188"
          style={{
            fontSize: 42.6667,
            lineHeight: 1,
            display: "inline",
            fill: "#67852f",
            fillOpacity: 1,
            stroke: "#67852f",
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          xmlSpace="preserve"
          id="text25"
        >
          <tspan
            x="363.99371"
            y="419.17435"
            id="tspan24"
            style={{
              fontSize: 42.6667,
              fill: "#67852f",
              fillOpacity: 1,
              stroke: "#67852f",
              strokeWidth: 1.54822,
              strokeOpacity: 1,
            }}
          >
            Biodiversity
          </tspan>
        </text>
        <text
          x="1140.2234"
          y="412.5929"
          fill="#7fa139"
          fontFamily="Alegreya Sans"
          fontSize="29.7965"
          letterSpacing="0.25998"
          stroke="#7fa139"
          strokeWidth="1.27997"
          text-align="center"
          textAnchor="middle"
          wordSpacing="-1.9969"
          style={{
            fontSize: 34.6667,
            lineHeight: 1.45,
            display: "inline",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            paintOrder: "markers stroke fill",
          }}
          xmlSpace="preserve"
          id="text42"
          transform="translate(-218.51103,-100.34835)"
        >
          <tspan
            x="1140.3557"
            y="412.5929"
            fill="#7fa139"
            letterSpacing="0.264585"
            strokeWidth="1.27997"
            id="tspan42"
            style={{ fontSize: 34.6667 }}
          >
            Story
          </tspan>
        </text>
        <text
          x="616.58258"
          y="413.18161"
          fill="#7fa139"
          fontFamily="Alegreya Sans"
          fontSize="29.7965"
          letterSpacing="0.25998"
          stroke="#7fa139"
          strokeWidth="1.27997"
          text-align="center"
          textAnchor="middle"
          wordSpacing="-1.9969"
          style={{
            fontSize: 29.3333,
            lineHeight: 1.45,
            display: "inline",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            paintOrder: "markers stroke fill",
          }}
          xmlSpace="preserve"
          id="text43"
          transform="translate(-218.51103,-100.34835)"
        >
          <tspan
            x="616.71484"
            y="413.18161"
            fill="#7fa139"
            letterSpacing="0.264585"
            strokeWidth="1.27997"
            id="tspan43"
            style={{ fontSize: 29.3333 }}
          >
            Empathy
          </tspan>
        </text>
        <text
          transform="matrix(0.99941697,0,0,1.0005833,-24.697304,-20.707618)"
          x="681.16205"
          y="312.08075"
          fill="#7fa139"
          fontSize="39.9014"
          letterSpacing="0.158194"
          stroke="#7fa139"
          strokeWidth="1.00554"
          text-align="center"
          textAnchor="middle"
          wordSpacing="-2.2188"
          style={{
            fontSize: 42.6667,
            lineHeight: 1,
            fontFamily: "Alegreya Sans",
            whiteSpace: "pre",
            inlineSize: 215.995,
            display: "inline",
            fill: "#67852f",
            fillOpacity: 1,
            stroke: "#67852f",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          xmlSpace="preserve"
          id="text50"
        >
          <tspan x="681.16205" y="312.08075" id="tspan2">
            <tspan dx="0 0 0 0 0 0 0 0 0 2.2187996" id="tspan1">
              Knowledge
            </tspan>
            <tspan y="312.08075" id="tspan3">
              {" "}
            </tspan>
          </tspan>
          <tspan x="681.16205" y="354.74743" id="tspan4">
            Protectors
          </tspan>
        </text>
        <g
          id="g73"
          transform="matrix(0.91697833,0,0,0.91697833,-158.66794,-9.3040586)"
        >
          <path
            style={{
              display: "inline",
              fill: "none",
              fillOpacity: 1,
              stroke: "none",
              strokeWidth: 6.04724,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: 16.6,
              strokeDasharray: "none",
              strokeOpacity: 1,
              paintOrder: "markers stroke fill",
            }}
            d="m 1036.3729,261.46369 c 18.6339,-38.73921 70.7973,-100.54994 111.6122,-126.52721"
            id="path70"
            transform="matrix(1.0905383,0,0,1.0905383,181.66897,70.595052)"
          />
          <path
            style={{
              display: "inline",
              fill: "none",
              fillOpacity: 1,
              stroke: "none",
              strokeWidth: 6.04724,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: 16.6,
              strokeDasharray: "none",
              strokeOpacity: 1,
              paintOrder: "markers stroke fill",
            }}
            d="m 1011.4401,240.82967 c 18.6339,-38.73921 70.7973,-100.54994 111.6122,-126.52721"
            id="path71"
            transform="matrix(1.0905383,0,0,1.0905383,181.66897,70.595052)"
          />
        </g>
        <path
          style={{
            display: "none",
            fill: "none",
            stroke: "#c7433b",
            strokeWidth: 7.55906,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeDasharray: "none",
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          d="m 706.71175,350.12622 c 16.88792,-52.08544 60.4449,-104.43228 116.38127,-129.18931"
          id="path38"
        />
        <path
          style={{
            display: "none",
            fill: "none",
            stroke: "#c7433b",
            strokeWidth: 7.55906,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeDasharray: "none",
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          d="m 523.44996,254.99586 c 25.26887,-47.65057 39.72556,-68.27468 82.605,-101.00613"
          id="path39"
        />
        <text
          xmlSpace="preserve"
          style={{
            fontSize: 29.3333,
            lineHeight: 1.6,
            fontFamily: "Alegreya Sans",
            textAlign: "center",
            letterSpacing: 0,
            wordSpacing: 2,
            direction: "ltr",
            textAnchor: "middle",
            fill: "#c5dafbff",
            fillOpacity: 1,
            stroke: "#c5dafbff",
            strokeWidth: 0.823937,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeDasharray: "none",
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          id="text82"
        >
          <textPath xlinkHref="#path39" startOffset="50%" id="textPath82">
            <tspan id="tspan82">Producers</tspan>
          </textPath>
        </text>

        <path
          style={{
            display: "none",
            fill: "none",
            fillOpacity: 1,
            stroke: "#99433b",
            strokeWidth: 5.35937,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeDasharray: "none",
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          d="m 944.39596,213.68153 c 42.61716,25.14092 83.98574,54.86326 110.50314,101.57229"
          id="path82"
        />
        <path
          id="path5-reversed-gradient"
          style={{
            fill: "none",
            fillOpacity: 0,

            strokeWidth: 15.7201,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          stroke="url(#reversed-gold-gradient-white-highlight-moving-right)"
          d="m 877.28151,202.1421 c -9.69479,2.30348 -37.02729,16.77326 -44.3497,24.91138 M 710.42715,360.64796 c -33.10987,68.52923 26.72881,141.99033 69.11409,153.76172 10.19519,3.16173 13.27142,4.5045 27.20137,6.11004 M 420.049,527.81418 c 27.05078,-0.98614 59.30905,-13.10511 79.84286,-33.36232 20.65912,-20.38082 30.34957,-66.95211 34.58174,-80.18942 -1.14697,-12.14903 -9.55125,-47.77065 -31.91609,-86.46164 m -68.90025,-74.39881 c -22.68822,-17.57784 -45.53443,-32.29568 -79.08617,-41.23054 -30.58487,7.73035 -59.94333,23.88007 -85.32003,45.25863 m -74.68371,110.59486 c -8.41268,23.30047 -9.57523,37.84742 -7.28975,61.00557 4.77397,48.37338 18.58187,71.76713 59.4179,94.24353 10.91702,6.00879 30.4075,6.7491 44.13527,7.39759 M 534.54408,414.58436 c 10.52454,-31.5918 37.3449,-68.01931 88.23289,-67.69319 47.4017,0.30377 57.69125,31.3072 76.1209,61.40771 m -4.75098,-0.92698 c -5.48293,24.45916 -23.12671,47.93412 -72.30673,48.03889 -49.18133,0.10477 -85.67954,-22.16149 -87.43703,-41.47026"
          transform="translate(-218.51103,-100.34835)"
        />
        <path
          id="path5"
          style={{
            fill: "none",
            fillOpacity: 0,
            strokeWidth: 15.7201,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          stroke="url(#gold-gradient-white-highlight-moving-right)"
          d="m 877.28151,202.1421 c -9.69479,2.30348 -37.02729,16.77326 -44.3497,24.91138 M 710.42715,360.64796 c -33.10987,68.52923 26.72881,141.99033 69.11409,153.76172 10.19519,3.16173 13.27142,4.5045 27.20137,6.11004 M 420.049,527.81418 c 27.05078,-0.98614 59.30905,-13.10511 79.84286,-33.36232 20.65912,-20.38082 30.34957,-66.95211 34.58174,-80.18942 -1.14697,-12.14903 -9.55125,-47.77065 -31.91609,-86.46164 m -68.90025,-74.39881 c -22.68822,-17.57784 -45.53443,-32.29568 -79.08617,-41.23054 -30.58487,7.73035 -59.94333,23.88007 -85.32003,45.25863 m -74.68371,110.59486 c -8.41268,23.30047 -9.57523,37.84742 -7.28975,61.00557 4.77397,48.37338 18.58187,71.76713 59.4179,94.24353 10.91702,6.00879 30.4075,6.7491 44.13527,7.39759 M 534.54408,414.58436 c 10.52454,-31.5918 37.3449,-68.01931 88.23289,-67.69319 47.4017,0.30377 57.69125,31.3072 76.1209,61.40771 m -4.75098,-0.92698 c -5.48293,24.45916 -23.12671,47.93412 -72.30673,48.03889 -49.18133,0.10477 -85.67954,-22.16149 -87.43703,-41.47026"
          transform="translate(-218.51103,-100.34835)"
        />
        <path
          id="path6-reversed-gradient"
          style={{
            fill: "none",
            fillOpacity: 0,
            strokeWidth: 15.7201,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          stroke="url(#reversed-gold-gradient-white-highlight-moving-left)"
          d="m 953.03809,518.68562 c 19.83679,-3.93366 29.66819,-9.50605 40.02619,-16.70864 36.73432,-25.5438 56.88782,-85.84488 60.58152,-95.57683 -2.3509,-17.25708 -7.3519,-35.55528 -14.6477,-53.56988 M 924.43705,228.68393 c -10.4083,-9.84349 -33.57712,-23.0355 -47.15554,-26.54183 m 265.57639,253.2765 c -46.4143,0 -84.3106,-20.80455 -89.2121,-49.01845 5.308,-19.02172 48.9551,-60.51137 88.1304,-59.35093 34.5826,1.0244 72.9305,36.42478 76.3578,53.3343 -6.1067,17.84455 -25.0917,55.03508 -75.2761,55.03508 z m 374.1293,58.0603 c 54.5206,-29.54725 46.2018,-106.89334 18.0855,-154.78292 m -79.8341,-116.54475 c -13.0934,-16.51778 -43.6386,-34.94517 -56.7795,-37.42498 -10.6815,2.69876 -38.7004,20.58108 -51.0713,31.91208 m -109.842,125.85346 c -7.5894,12.80258 -14.3927,31.56444 -19.4118,37.89173 9.9624,53.83004 21.2104,100.09275 71.1504,122.97719"
          transform="translate(-218.51103,-100.34835)"
        />
        <path
          id="path6"
          style={{
            fill: "none",
            fillOpacity: 0,

            strokeWidth: 15.7201,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 16.6,
            strokeOpacity: 1,
            paintOrder: "markers stroke fill",
          }}
          stroke="url(#gold-gradient-white-highlight-moving-left)"
          d="m 953.03809,518.68562 c 19.83679,-3.93366 29.66819,-9.50605 40.02619,-16.70864 36.73432,-25.5438 56.88782,-85.84488 60.58152,-95.57683 -2.3509,-17.25708 -7.3519,-35.55528 -14.6477,-53.56988 M 924.43705,228.68393 c -10.4083,-9.84349 -33.57712,-23.0355 -47.15554,-26.54183 m 265.57639,253.2765 c -46.4143,0 -84.3106,-20.80455 -89.2121,-49.01845 5.308,-19.02172 48.9551,-60.51137 88.1304,-59.35093 34.5826,1.0244 72.9305,36.42478 76.3578,53.3343 -6.1067,17.84455 -25.0917,55.03508 -75.2761,55.03508 z m 374.1293,58.0603 c 54.5206,-29.54725 46.2018,-106.89334 18.0855,-154.78292 m -79.8341,-116.54475 c -13.0934,-16.51778 -43.6386,-34.94517 -56.7795,-37.42498 -10.6815,2.69876 -38.7004,20.58108 -51.0713,31.91208 m -109.842,125.85346 c -7.5894,12.80258 -14.3927,31.56444 -19.4118,37.89173 9.9624,53.83004 21.2104,100.09275 71.1504,122.97719"
          transform="translate(-218.51103,-100.34835)"
        />
      </g>
      <text
        xmlSpace="preserve"
        style={{
          fontSize: 29.3333,
          lineHeight: 1.6,
          fontFamily: "Alegreya Sans",
          textAlign: "center",
          letterSpacing: 0,
          wordSpacing: 2,
          direction: "ltr",
          textAnchor: "middle",
          fill: "#c5dafbff",
          fillOpacity: 1,
          stroke: "#c5dafbff",
          strokeWidth: 0.823937,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeMiterlimit: 16.6,
          strokeDasharray: "none",
          strokeOpacity: 1,
          paintOrder: "markers stroke fill",
        }}
        id="text80"
      >
        <textPath xlinkHref="#path68" startOffset="50%" id="textPath80">
          <tspan id="tspan80">Catalysts</tspan>
        </textPath>
      </text>
      <text
        xmlSpace="preserve"
        style={{
          fontSize: 29.3333,
          lineHeight: 1.6,
          fontFamily: "Alegreya Sans",
          textAlign: "center",
          letterSpacing: 0,
          wordSpacing: 2,
          direction: "ltr",
          textAnchor: "middle",
          display: "inline",
          fill: "#c5dafbff",
          fillOpacity: 1,
          stroke: "#c5dafbff",
          strokeWidth: 0.823937,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeMiterlimit: 16.6,
          strokeDasharray: "none",
          strokeOpacity: 1,
          paintOrder: "markers stroke fill",
        }}
        id="text81"
        transform="translate(5.8688032,5.7007731)"
      >
        <textPath xlinkHref="#path38" startOffset="50%" id="textPath81">
          <tspan id="tspan81">Heritage Grain</tspan>
        </textPath>
      </text>
    </svg>
  );
};
